import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DefaultChip',
  props: {
    variant: {}
  },
  setup(__props: any) {

const props = __props;

const VARIANTS = {
  gray: 'bg-gray-50 border-gray-300',
  yellow: 'bg-brand-50 border-brand-500',
  green: 'bg-success-50 border-success-300',
  blue: 'bg-blue-50 border-blue-300',
  pink: 'bg-pink-50 border-pink-300',
  orange: 'bg-orange-50 border-orange-300',
  light_blue: 'bg-sky-50 border-sky-300',
} as const;

function isValidVariant(variant: string): variant is keyof typeof VARIANTS {
  return variant in VARIANTS;
}

const variant = computed(() => {
  if (props.variant === null) {
    return VARIANTS.yellow;
  }

  if (isValidVariant(props.variant)) {
    return VARIANTS[props.variant];
  }

  return VARIANTS.yellow;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-nowrap rounded-full border px-2.5 py-0.5 text-sm font-medium text-gray-700", variant.value])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})